








































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import {
  InsertQualityControlSet,
  UpdateQualityControlSet
} from "@/api/pdQualityControlManage/pdQualityControlSet";
@Component({})
export default class PdQualityControlSetAdd extends AbpBase {
  @Prop() pdQualityControlSet: any;
  qualityControl: any = {};
  QualityControlType: any[] = [];
  rules = {
    type: [
      {
        required: true,
        type: "number",
        message: "检查项目不能为空",
        trigger: "change"
      }
    ]
  };

  @Watch("pdQualityControlSet", { immediate: false, deep: true })
  onQualityControlSetChanged() {
    if (this.pdQualityControlSet) {
      var newObj = Object.assign({}, this.pdQualityControlSet);
      this.qualityControl = newObj;
    }
  }

  resetForm() {
    this.$refs["form"].resetFields();
  }

  initDic() {
    GetListByCode({ input: "PD_Dic_QC_Type" }).then(res => {
      this.QualityControlType = res;
      console.log(this.QualityControlType);
    });
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.qualityControl.id == 0) {
        await InsertQualityControlSet(this.qualityControl);
      } else {
        await UpdateQualityControlSet(this.qualityControl);
      }

      return true;
    }

    return false;
  }

  constructor() {
    super();
    this.initDic();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdQualityControlSet/pdQualityControlSetAdd.vue